import React from "react";

import "./style.scss";

export default function Enreading() {
  return (
    <div className="enreading">
      <iframe src="/enreading/home"></iframe>
    </div>
  )
}